import React, { useEffect, useState } from 'react';
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import {
    Container,
    Row,
    Col,
} from "reactstrap";
import TaskScreen from './TaskScreen';
import { fetchData, FetchPostData } from 'utils/common-fetchData';
import secureLocalStorage from 'react-secure-storage';
import { useParams } from 'react-router-dom';
import Loader from 'pages/Separate/Loader';

import "../../../assets/css/Finance/Style/PayrollManagement/payroll_management.css"

const ResourceIndex = () => {
    const [isLoading, setLoading] = useState(false);
    const [projectDetails, setProjectDetail] = useState({})
    const token = secureLocalStorage.getItem("auth_token")
    const toggleLoading = (loading) => {
        setLoading(loading)
    }
    const params = useParams();
    const fetchProjects = async (type) => {
        const user_id = localStorage.getItem('auth_id')
        const roleId = secureLocalStorage.getItem('auth_role')
        const res = await fetchData(
            toggleLoading,
            `unplanProjects/${user_id}/${roleId}`,
            token
        )
        if (res?.success) {
            const projects = res?.data?.projects
            if (type != 2) {
                setProjectDetail(projects?.find((obj) => obj?.id == params?.id))
            }
        }
    }
    useEffect(() => {
        fetchProjects()
    }, [])

    const onUpdateDetails = (call, type) => {
        if (call) {
            fetchProjects(type);
        }
    }
    return (
        <React.Fragment>
            {isLoading && (<Loader />)}
            <div className="page-content mb-4">
                <Container fluid >
                    <Breadcrumbs
                        title={"Project Plan"}
                   breadcrumbItem={projectDetails?.project_name}
                    />
                    <div id="credentialPage">
                        <Row >
                            <Col md={"12"}
                                className={`z-1 pe-0   ps-0`}>
                                <TaskScreen projectDetails={projectDetails} toggleLoading={toggleLoading} onUpdate={onUpdateDetails} />
                            </Col>
                        </Row>
                    </div>
                </Container>
            </div>
        </React.Fragment>
    )
}

export default ResourceIndex;